import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import * as actions from "../actions/homepage";
import {
  GET_MARKET_PROCESSES_LIST_REQUEST,
  GET_GENERAL_OPERATIONS_LIST_REQUEST,
  GET_CHART_DATA_REQUEST,
  GET_ORGANIZED_MARKET_INFO_REQUEST,
  GET_SYSTEM_MSG_LIST_REQUEST,
  GET_HOME_OBJECTIONS_LIST_REQUEST,
  GET_HOME_BILATERAL_LIST_REQUEST,
  GET_BILATERAL_SANDB_LIST_REQUEST,
  GET_HOME_PRODUCTION_DATA_REQUEST,
  GET_HOME_ACTIVE_CERTIFICATES_REQUEST,
} from "../types";
import { API_GET, API_AUDIT } from "../../helpers/api";
import moment from "moment";

// MARKET PROCESSES SAGA
function* watchGetMarketProcessesList() {
  yield takeEvery(GET_MARKET_PROCESSES_LIST_REQUEST, getMarketProcessesList);
}

function* getMarketProcessesList(action) {
  try {
    const res = yield call(apiGetMarketProcessesList);
    yield put(actions.getMarketProcessesListSucceeded([...res.data]));
  } catch (err) {
    yield put(actions.getMarketProcessesListFailed());
  }
}

const apiGetMarketProcessesList = () => API_GET("system-parameter/process");

// GENERAL OPERATIONS SAGA
function* watchGetGeneralOperationsList() {
  yield takeEvery(
    GET_GENERAL_OPERATIONS_LIST_REQUEST,
    getGeneralOperationsList
  );
}

function* getGeneralOperationsList(action) {
  try {
    const { url, reqParams } = action.payload;
    const res = yield call(apiGetGeneralOperationsList, url, reqParams);
    yield put(actions.getGeneralOperationsListSucceeded([...res.data.items]));
  } catch (err) {
    yield put(actions.getGeneralOperationsListFailed());
  }
}

const apiGetGeneralOperationsList = (url, reqParams) =>
  API_GET(url, {
    ...reqParams,
    page: 0,
    size: 5,
  });

// CHART DATA SAGA
function* watchGetChartData() {
  yield takeEvery(GET_CHART_DATA_REQUEST, getChartData);
}

function* getChartData(action) {
  try {
    const res = yield call(apiGetChartData, {
      ...action.payload,
    });
    yield put(actions.getChartDataSucceeded({ ...res.data }));
  } catch (err) {
    yield put(actions.getChartDataFailed());
  }
}

const apiGetChartData = (reqParams) =>
  API_GET("certificate/statistics", {
    ...reqParams,
  });

// ORGANIZED MARKET INFO SAGA
function* watchGetOrganizedMarketInfo() {
  yield takeEvery(GET_ORGANIZED_MARKET_INFO_REQUEST, getOrganizedMarketInfo);
}

function* getOrganizedMarketInfo(action) {
  try {
    const res = yield call(apiGetOrganizedMarketInfo);
    yield put(actions.getOrganizedMarketInfoSucceeded({ ...res.data }));
  } catch (err) {
    yield put(actions.getOrganizedMarketInfoFailed());
  }
}

const apiGetOrganizedMarketInfo = () =>
  API_GET("system-parameter/session/last-closed");

// SYSTEM MSG SAGA
function* watchGetSystemMsgList() {
  yield takeEvery(GET_SYSTEM_MSG_LIST_REQUEST, getSystemMsgList);
}

function* getSystemMsgList(action) {
  try {
    const res = yield call(apiGetSystemMsgList, action.payload);
    yield put(
      actions.getSystemMsgListSucceeded({
        items: [...res.data.items],
        activePage: res.data.currentPage,
        totalPageCount: Math.ceil(
          res.data.totalItemCount / action.payload.size
        ),
      })
    );
  } catch (err) {
    yield put(actions.getSystemMsgListFailed());
  }
}

const apiGetSystemMsgList = (reqParams) =>
  API_AUDIT("audit/search", {
    ...reqParams,
  });

// HOME OBJECTIONS SAGA
function* watchGetHomeObjectionsList() {
  yield takeEvery(GET_HOME_OBJECTIONS_LIST_REQUEST, getHomeObjectionsList);
}

function* getHomeObjectionsList(action) {
  try {
    const res = yield call(apiGetHomeObjectionsList);
    const objectionList = res.data.items.map((item) => ({
      id: item.id,
      organizationName: item?.organizationName,
      userName: item?.username,
      contractName: item?.exchangeOrderDto?.contractName,
      createdAt: item?.createdAt
        ? moment(item?.createdAt).format("DD.MM.YYYY HH:mm:ss")
        : "",
      bidId: item?.exchangeOrderDto.id,
      answeredAt: item?.answeredAt
        ? moment(item?.answeredAt).format("DD.MM.YYYY HH:mm:ss")
        : "",
    }));
    yield put(actions.getHomeObjectionsListSucceeded([...objectionList]));
  } catch (err) {
    yield put(actions.getHomeObjectionsListFailed());
  }
}

const apiGetHomeObjectionsList = () =>
  API_GET("objections", {
    page: 0,
    size: 5,
  });

// HOME BILATERAL SAGA
function* watchGetHomeBilateralList() {
  yield takeEvery(GET_HOME_BILATERAL_LIST_REQUEST, getHomeBilateralList);
}

function* getHomeBilateralList(action) {
  const params = {
    status: ["INITIAL", "AGREEMENT"],
    page: 0,
    size: 5,
  };
  try {
    const [sellerInfoRes, buyerInfoRes] = yield all([
      call(apiGetBilateralList, {
        fromOrganizationId: action.payload,
        ...params,
      }),
      call(apiGetBilateralList, {
        toOrganizationId: action.payload,
        ...params,
      }),
    ]);
    const resList = [...sellerInfoRes.data.items, ...buyerInfoRes.data.items];
    resList.sort(sortList);
    yield put(actions.getHomeBilateralListSucceeded(resList.slice(0, 5)));
  } catch (err) {
    yield put(actions.getHomeBilateralListFailed());
  }
}

const sortList = (a, b) =>
  a.createdDate > b.createdDate ? -1 : b.createdDate > a.createdDate ? 1 : 0;

// BILATERAL S AND B SAGA
function* watchGetBilateralSAndBList() {
  yield takeEvery(GET_BILATERAL_SANDB_LIST_REQUEST, getBilateralSAndBList);
}

function* getBilateralSAndBList(action) {
  const startDate = moment().subtract(3, "day").format("DD-MM-YYYY");
  const endDate = moment().format("DD-MM-YYYY");
  const params = {
    startDate,
    endDate,
    status: "SUCCESSFUL",
  };
  try {
    const [sellerInfoRes, buyerInfoRes] = yield all([
      call(apiGetBilateralList, {
        fromOrganizationId: action.payload,
        ...params,
      }),
      call(apiGetBilateralList, {
        toOrganizationId: action.payload,
        ...params,
      }),
    ]);
    const groupedSellerList = {
      processType: "SATIS",
      ...groupByCreatedDate(sellerInfoRes.data.items),
    };
    const groupedBuyerList = {
      processType: "ALIS",
      ...groupByCreatedDate(buyerInfoRes.data.items),
    };
    yield put(
      actions.getBilateralSAndBListSucceeded([
        groupedSellerList,
        groupedBuyerList,
      ])
    );
  } catch (err) {
    yield put(actions.getBilateralSAndBListFailed());
  }
}

const groupByCreatedDate = (data) =>
  data.reduce((acc, item) => {
    const group = `amount${moment(item.createdDate).format("D")}`;
    acc[group] = acc[group] || 0;
    acc[group] += item.amount;
    return acc;
  }, {});

const apiGetBilateralList = (reqParams) =>
  API_GET("bilateralAgreement", {
    ...reqParams,
  });

// HOME PRODUCTION DATA SAGA
function* watchGetHomeProductionData() {
  yield takeEvery(GET_HOME_PRODUCTION_DATA_REQUEST, getHomeProductionData);
}

function* getHomeProductionData(action) {
  try {
    const res = yield call(apiGetHomeProductionData, {
      organizationId: action.payload,
      gddk: false,
    });
    const groupedProductionList = groupByTerm(res.data.items);
    yield put(
      actions.getHomeProductionDataSucceeded([
        {
          id: action.payload,
          ...groupedProductionList,
        },
      ])
    );
  } catch (err) {
    yield put(actions.getHomeProductionDataFailed());
  }
}

const groupByTerm = (data) =>
  data.reduce((acc, item) => {
    const group = `amount${moment(item.term).format("M")}`;
    acc[group] = acc[group] || 0;
    acc[group] += item.certifiableAmount;
    if (item.gddkProductionData) {
      const gddkGroup = `amount${moment(item.gddkProductionData.term).format(
        "M"
      )}`;
      acc[gddkGroup] = acc[gddkGroup] || 0;
      acc[gddkGroup] += item.gddkProductionData.certifiableAmount;
    }
    return acc;
  }, {});

const apiGetHomeProductionData = (reqParams) =>
  API_GET("production-data", {
    ...reqParams,
    page: 0,
    size: 10000,
  });

// HOME ACTIVE CERTIFICATES SAGA
function* watchGetHomeActiveCertificates() {
  yield takeEvery(
    GET_HOME_ACTIVE_CERTIFICATES_REQUEST,
    getHomeActiveCertificates
  );
}

function* getHomeActiveCertificates(action) {
  try {
    const res = yield call(apiGetHomeActiveCertificates, action.payload);
    yield put(
      actions.getHomeActiveCertificatesSucceeded([
        {
          id: action.payload,
          ...res.data,
        },
      ])
    );
  } catch (err) {
    yield put(actions.getHomeActiveCertificatesFailed());
  }
}

const apiGetHomeActiveCertificates = (organizationId) =>
  API_GET(`certificate/organization/${organizationId}/statistics`);

export default function* homepageSaga() {
  yield all([
    fork(watchGetMarketProcessesList),
    fork(watchGetGeneralOperationsList),
    fork(watchGetChartData),
    fork(watchGetOrganizedMarketInfo),
    fork(watchGetSystemMsgList),
    fork(watchGetHomeObjectionsList),
    fork(watchGetHomeBilateralList),
    fork(watchGetBilateralSAndBList),
    fork(watchGetHomeProductionData),
    fork(watchGetHomeActiveCertificates),
  ]);
}
